// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerShipToAddressStyles } from "@tps/Overrides/Widgets/Common/HeaderShipToAddress";
import { color, ellipsis, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

headerShipToAddressStyles.titleLink = {
    lineHeight: "22px",
    size: 14,
    weight: "normal",
    css: css`
        ${ellipsis(1)};
        &&& {
            color: ${color("text.main")};
        }
        ${xScreen("lte", "1200")} {
            font-size: 12px;
        }
        margin-left: 4px;
    `,
};

headerShipToAddressStyles.titleTypography = {
    lineHeight: "22px",
    size: 14,
    weight: "bold",
    css: css`
        text-wrap: nowrap;
        ${xScreen("lte", "1200")} {
            font-size: 12px;
        }
    `,
};

headerShipToAddressStyles.shipToAddressWrapper = {
    css: css`
        display: inline-flex;
        width: 100%;
    `,
};
